import NavigationScroll from "container/layout/NavigationScroll";

import { lazy } from "react";
import {
  createBrowserRouter,
  Outlet,
} from "react-router-dom";
import Loader from "ui-component/Loader";
import { AuthProvider } from "./auth.provider";
import GuestRoute from "./GuestRoute";
import ProtectedUserRoute from "./ProtectedRoute";
import Reconciliation from "pages/reconciliation";
import Paymentfailed from "pages/payments/Paymentfailed";
import Paymentsuccess from "pages/payments/Paymentsuccess";

const ReconciliationList = lazy(() => import("pages/reconciliation/ReconciliationList"))

/* guest routes */
const PageNotFound = lazy(() => import("pages/pagenotfound"));
const ComingSoon = lazy(() => import("forms/hoc/coming-soon"));
const PublicPage = lazy(() => import("pages/publicPage"))

const Login = lazy(() => import("pages/authentication/Login"));
const LandingPage = lazy(() => import("pages/landingPage"));

const ForgotPassword = lazy(
  () => import("pages/authentication/ForgotPassword")
);

/* layout component */
const Layout = lazy(() => import("../layout/layout/MainLayout"));


const Report = lazy(() => import("pages/reports"))

const Subscription = lazy(() => import("pages/reports/SubcriptionPlan"))

const CoursePage = lazy(() => import("pages/course"))

const PolicyReports = lazy(() => import("pages/reports/Policy"))

const CourseReport = lazy(() => import("pages/reports/CourseReport"))

const AsiStudentReport = lazy(() => import("pages/reports/AsiStudentReport"))

const ApprovedBrokerView = lazy(() => import("pages/approvedBrokerList/ApprovedBrokerView"))

const BrokerEdit = lazy(() => import("pages/approvedBrokerList/tabs/index"));

// Pages

const RequestList = lazy(() => import("pages/brokerEnquiryList"));
const BrokerEnquiryView = lazy(() => import("pages/brokerEnquiryList/BrokerEnquiryView"))
const BrokerEnquiryEdit = lazy(() => import("pages/brokerEnquiryList/BrokerEnquiryEdit"))


const ApprovedList = lazy(() => import("pages/approvedBrokerList"));
const CreateBroker = lazy(() => import("pages/approvedBrokerList/CreateBroker"));

// Enhanced Broker Management
const EnhancedBrokerList = lazy(() => import("pages/enhanced-broker/EnhancedBrokerList"));
const EnhancedBrokerEdit = lazy(() => import("pages/enhanced-broker/EnhancedBrokerEdit"));
const EnhancedBrokerView = lazy(() => import("pages/enhanced-broker/EnhancedBrokerView"));

const BrokerEnquiry = lazy(() => import("pages/brokerEnquiry"));



const MasterList = lazy(() => import("pages/masterList"));

const SubBrokerList = lazy(() => import("pages/sub-broker"));

const Settings = lazy(() => import("pages/Settings"))

const PlanList = lazy(() => import("pages/plans"))


const FeatureList = lazy(() => import("pages/features"))


const Profile = lazy(() => import("pages/profile"));
const ResetPassword = lazy(() => import("pages/resetPassword"));

const Dashboard = lazy(() => import("pages/dashboard/index"));

const EmployeeAndLocationManagement = lazy(() => import("pages/employeeLocation/index"));

const Redirect = lazy(() => import("pages/redirect/index"));

const NotificationSection = lazy(() => import("pages/notification/index"))


const appLoader = () => {
  return <Loader />;
};



const AuthLayout = () => (
  <AuthProvider>
    <NavigationScroll>
      <Outlet />
    </NavigationScroll>
  </AuthProvider>
);

const RoutePath = createBrowserRouter(
  [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: "/",
          element: <GuestRoute />,
          loader: appLoader,
          children: [
            {
              path: "",
              element: <LandingPage />,
            },
            {
              path: "/subscriptionPlans",
              element: <PublicPage />
            },
            {
              path: "/login",
              element: <Login />,
            },
            {
              path: "broker_details",
              element: <BrokerEnquiry />,
            },
            {
              path: "/forgotpassword",
              element: <ForgotPassword />,
            },
            {
              path: "/payment/failed",
              element: <Paymentfailed />,
            },
            {
              path: "/payment/success",
              element: <Paymentsuccess />,
            },
            {
              path: "/redirect",
              element: <Redirect />
            },
            {
              path: "/course",
              element: <CoursePage />,
            }

          ],
        },
        {
          path: "/",
          element: <ProtectedUserRoute />,
          children: [
            {
              path: "",
              element: <Layout />,
              children: [
                {
                  path: "/dashboard",
                  element: <Dashboard />
                },
                {
                  path: "/enquires",
                  element: <RequestList />,
                },
                {
                  path: "/enquiry/view/:id",
                  element: <BrokerEnquiryView />,
                },
                {
                  path: "/enquiry/edit/:id",
                  element: <BrokerEnquiryEdit />,
                },
                // Old Broker Management Routes (commented out)
                // {
                //   path: "/brokers-old",
                //   element: <ApprovedList />,
                // },
                // {
                //   path: "/broker-old/create",
                //   element: <CreateBroker />,
                // },
                // {
                //   path: "/broker-old/view/:id",
                //   element: <ApprovedBrokerView />,
                // },
                // {
                //   path: "/broker-old/edit/:id",
                //   element: <BrokerEdit />
                // },
                // Enhanced Broker Management Routes (now main broker routes)
                {
                  path: "/brokers",
                  element: <EnhancedBrokerList />,
                },
                {
                  path: "/broker/create",
                  element: <CreateBroker />,
                },
                {
                  path: "/broker/view/:id",
                  element: <EnhancedBrokerView />,
                },
                {
                  path: "/broker/edit/:id",
                  element: <EnhancedBrokerEdit />,
                },
                {
                  path: "/reports",
                  element: <Report />,
                },
                {
                  path: "/reports/subscription-report",
                  element: <Subscription />,
                },
                {
                  path: "/reports/policy-report",
                  element: <PolicyReports />,
                },
                {
                  path: "/reports/course-report",
                  element: <CourseReport />,
                },
                {
                  path: "/reports/asi-student-report",
                  element: <AsiStudentReport />,
                },
                {
                  path: "/settings",
                  element: <Settings />,
                },
                {
                  path: "/settings/masters",
                  element: <MasterList />,
                },
                {
                  path: "/sub-brokers",
                  element: <SubBrokerList />,
                },
                // {
                //   path:"/settings/landing",
                //   element:<Landing/>
                // },
                {
                  path: "/settings/plans",
                  element: <PlanList />,
                },
                {
                  path: "/settings/features",
                  element: <FeatureList />,
                },
                {
                  path: "/settings/employee-location-management",
                  element: <EmployeeAndLocationManagement />
                },
                {
                  path: "/profile",
                  element: <Profile />,
                },
                {
                  path: "/resetPassword",
                  element: <ResetPassword />,
                },
                {
                  path: "/coming_soon",
                  element: <ComingSoon />,
                },
                {
                  path: "/reconciliation",
                  element: <ReconciliationList />
                },
                {
                  path: "/reconciliation/upload",
                  element: <Reconciliation />
                },
                {
                  path: "/notification",
                  element: <NotificationSection />
                }

              ],
            },
          ],
        },
        {
          path: "*",
          element: <PageNotFound />,
        },
        {
          path: "404",
          element: <PageNotFound />,
        },
      ],
    }
  ],
  {
    basename: "/",
  }
);


export default RoutePath;
